import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPencil,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { Container } from "components";
import Pagination from "components/pagination";
import { useToaster } from "hooks";
import moment from "moment";
import api from "services/api";

export const PartnerCategoriesList = () => {
  const [categories, setCategories] = useState({ partner_categories: [], pagination: {} });
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const { setErrorToaster, setSuccessToaster } = useToaster();

  const fetchCategories = async (page = 1) => {
    try {
      const response = await api.get(`/partner-categories?page=${page}`);
      setCategories(response?.data?.data || { partner_categories: [], pagination: {} });
      setCurrentPage(page);
      console.log("fetchCategories list:", response?.data?.data);
    } catch (error) {
      console.log("fetchCategories errors:", error);
      setErrorToaster("Failed to fetch partner categories");
    }
  };

  useEffect(() => {
    fetchCategories(1);
  }, []);

  const openDeleteModal = (id) => {
    setSelectedCategoryId(id);
    setDeleteModal(true);
  };

  const handleDeleteModelConfirmation = async () => {
    if (selectedCategoryId) {
      try {
        const response = await api.delete(`/partner-categories/${selectedCategoryId}`);
        console.log("handleDeleteModelConfirmation:", response);
        setDeleteModal(false);
        setSelectedCategoryId(null);
        fetchCategories(currentPage);
        setSuccessToaster("Successfully deleted partner category");
      } catch (error) {
        console.log("handleDeleteModelConfirmation Error:", error);
        setErrorToaster(error?.response?.data?.message || "Failed to delete partner category");
      }
    }
  };

  const getStatusBadge = (status) => {
    const statusClasses = {
      Active: "bg-success",
      Inactive: "bg-secondary",
    };
    return statusClasses[status] || "bg-secondary";
  };

  return (
    <Container>
      <div className="content-wrapper">
        <div
          className="container-xxl flex-grow-1 container-p-y"
          style={{ height: "43px" }}
        >
          <h4 className="card-header">Partner Categories</h4>
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-primary me-5 mb-4"
              onClick={() => navigate("/addPartnerCategory")}
            >
              Add Partner Category
            </button>
          </div>
          <div className="card-datatable table-responsive">
            <table className="invoice-list-table table border-top dataTable no-footer dtr-column mb-5">
              <thead>
                <tr>
                  <th>Sno</th>
                  <th>Name</th>
                  <th>Status</th>
                  <th>Created On</th>
                  <th>Updated On</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {categories?.partner_categories?.map((category, index) => {
                  const serialNumber =
                    (currentPage - 1) * (categories?.pagination?.per_page || 10) +
                    (index + 1);
                  return (
                    <tr key={category.category_id}>
                      <td>{serialNumber}</td>
                      <td>{category?.name}</td>
                      <td>
                        <span className={`badge ${getStatusBadge(category?.status)}`}>
                          {category?.status}
                        </span>
                      </td>
                      <td>
                        {category?.created_on
                          ? moment(category.created_on).format("DD-MM-YYYY")
                          : "-"}
                      </td>
                      <td>
                        {category?.updated_on
                          ? moment(category.updated_on).format("DD-MM-YYYY")
                          : "-"}
                      </td>
                      <td>
                        <FontAwesomeIcon
                          title="Edit"
                          icon={faPencil}
                          className="me-3"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            navigate(`/editPartnerCategory/${category.category_id}`)
                          }
                        />
                        <FontAwesomeIcon
                          icon={faTrash}
                          style={{ cursor: "pointer", color: "#dc3545" }}
                          onClick={() => openDeleteModal(category.category_id)}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {categories?.pagination?.total > 0 && (
              <Pagination
                totalPages={categories?.pagination?.total}
                perPage={categories?.pagination?.per_page}
                handleFunction={fetchCategories}
              />
            )}
          </div>
        </div>
      </div>
      {deleteModal && (
        <div className="modal show d-block" tabIndex={-1}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Are you sure you want to delete this partner category?
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setDeleteModal(false)}
                ></button>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-primary"
                  onClick={() => setDeleteModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-danger"
                  onClick={handleDeleteModelConfirmation}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Container>
  );
};

